import FillInfo from './fill-info'
export default FillInfo
